import { render, staticRenderFns } from "./artikelsearch.vue?vue&type=template&id=e503ae7a&scoped=true"
import script from "./artikelsearch.vue?vue&type=script&lang=js"
export * from "./artikelsearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e503ae7a",
  null
  
)

/* custom blocks */
import block0 from "./artikelsearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports